// Libs
import axios from "../configRequest";
// Data
import { I_AXIOS } from "../configRequest.model";
import {
    I_sendBuyoutReject_response,
    I_sendBuyoutReject_fetch_response,
} from "./apiSendBuyoutReject.type";

const apiSendBuyoutReject: I_sendBuyoutReject_response = async (token, data) => {
    const fetchData = await axios.post<I_sendBuyoutReject_fetch_response>(
        I_AXIOS.STAGE_API_HOST + "/api/tin/v1/site/quest/agc-status",
        { ...data, token },
        {
            headers: {
                "x-auth-token": token,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        },
    );

    return fetchData.data;
};

export default apiSendBuyoutReject;
